import React from "react";
import TablePage from '../components/TablePage'
import TablePageHeader from '../components/TablePageHeader'
import RemoveModal from '../components/Modals/RemoveModal'
import ItemModal from '../components/Modals/ItemModal'
import FilterModal from '../components/Modals/FilterModal'

import { pagesData } from '../PagesData'
import { Route, Redirect } from 'react-router-dom'
import Loader from 'react-loader-spinner'
import { domain, headers, content } from '../Variables'
import Sidebar from "../components/SidebarR.jsx";
import dashboardRoutes from "../routers.jsx";
import Footer from "../components/Footer.jsx";
import Container from '../components/Container'
import Modal from '../components/Modal'
import ButtonCell from '../components/Table/Button'
import { FilterFields, FilterOperators } from '../Jsons/FilterData'

import HandleAdd from '../handle.add'
import GuaranteePageHeader from "../components/GuaranteePageHeader";
import { saveAs } from 'file-saver';

class GuaranteeApplet extends React.Component {

  constructor(prop) {
    super(prop)
    this.state = {
      data: [],
      removeData: null,
      page: null,
      modalIsOpen: false,
      actions: [{ title: 'ویرایش', action: 'edit', color: '#78b2d0' }, { title: 'حذف', action: 'remove', color: '#dd8aa4' }],
      actionIndex: null,
      // filterItem: { values: {} },
      filterItem: {},
      filterItemMock: {},
      guaranteeHeaders: [
        { key: 'count', type: 'numberCell', information: { label: 'Count', icon: 'https://image.flaticon.com/icons/svg/3037/3037852.svg', placeholder: 'insertTitle', required: true } },
        { key: 'months', type: 'numberCell', information: { label: 'Months', icon: 'https://image.flaticon.com/icons/svg/3037/3037852.svg', placeholder: 'insertTitle', required: true } },
        { key: 'creationDate', type: 'dateCell', information: { label: 'Creation date', icon: 'https://image.flaticon.com/icons/svg/3037/3037852.svg', placeholder: 'insertTitle', required: true } },
        { key: 'product', type: 'selectApiCell', information: { label: 'Product', icon: 'https://image.flaticon.com/icons/svg/3037/3037852.svg', address: '/values/getAllWithData', filter: { applet: 'products' }, titleField: 'values.name', fields: { title: 'values.name', value: '_id' }, type: 'api', required: true } },

      ],
      currentPage: 0,
      limit: 10
    }
  }


  componentWillMount() {
    // console.log("HEWKLDJWK")
    this.unlisten = this.props.history.listen((location, action) => {
      // this.loadPageData()
      this.setState({ lockSend: false, lockedItems: {} })
    });
    // this.loadPageData()
  }


  componentWillUnmount() {
    this.unlisten();
  }


  componentDidMount() {
    this.fetch()
    // this.refs.downloadFile.showModal()

  }


  fetch(getCount) {

    this.setState({ isLoadingData: true, data: [] })

    let body = { filter: {} }

    // if (this.props.page.settings && this.props.page.settings.fetchFilter) {
    //   body.filter = this.props.page.settings.fetchFilter
    // }
    // if (this.props.page && this.props.page.applet) {
    //   body.filter.applet = this.props.page.applet
    // }

    body.limit = this.state.limit
    body.skip = this.state.currentPage
    if (this.state.totalCount == null || getCount) {
      body.getCount = true
    }

    if (this.state.filterItem) {
      for (const [key, value] of Object.entries(this.state.filterItem)) {
        body.filter[key] = value
      }
    }

    let api = this.props.page.fetchUrl ? this.props.page.fetchUrl : '/values/getAllWithData'
    fetch(domain + api, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: headers
    }).then(response => response.json()).then(data => {
      this.setState({ isLoadingData: false })
      // console.log(data)
      if (data.status == 200) {
        this.setState({ data: data.info })
        if (data.count != null) {
          this.setState({ totalCount: data.count })
        }
      }
    }).catch(error => this.setState({ error, isLoading: false }));
  }



  fetchAddGuarantee = () => {
    this.setState({ errors: {} })

    let handleAdd = new HandleAdd()
    let page = {}
    page.headers = this.state.guaranteeHeaders
    page.addUrl = '/guarantee/addGuarantees'

    handleAdd.fetchAdd(page, this.state.currentItem, (data, errors) => {

      if (errors) {
        if (typeof errors == "object") {
          this.setState({ errors: errors })
        }
        this.setState({ isLoading: false })
        return
      }

      if (data.status == 200) {

        // this.refs.downloadFile.showModal()
        saveAs(content + '/files/' + data.file)

        this.refs.addItemModal.hideModal()
        this.setState({ data: [] }, () => {
          this.fetch()
        })

      }


    })

  }


  fetchAdd = () => {
    this.setState({ errors: {} })

    let handleAdd = new HandleAdd()

    handleAdd.fetchAdd(this.props.page, this.state.currentItem, (data, errors) => {

      if (errors) {
        if (typeof errors == "object") {
          this.setState({ errors: errors })
        }
        this.setState({ isLoading: false })
        return
      }

      if (data.status == 200) {

        if (this.state.lockSend && this.state.selectedIndex == -1) {
          this.addAction()
        } else {
          this.setState({ modalIsOpen: false })
          this.refs.itemModal.hideModal()
        }

        let newData = this.state.data

        if (this.state.selectedIndex == -1) {
          // this.props.loadPageData()
          this.setState({ data: [] }, () => {
            this.fetch()
          })

        } else {
          // console.log("UPDATE")
          // console.log(this.state.selectedIndex)
          delete this.state.currentItem['**files']
          newData[this.state.selectedIndex] = this.state.currentItem
          // this.props.changeData(newData)
          this.setState({ data: newData })

        }
      }


    })
  }






  fetchRemove = (id, index, modal) => {

    fetch(domain + this.props.urls.remove, {
      method: 'POST',
      body: JSON.stringify({ "id": id }),
      headers: headers
    }).then(response => response.json()).then(data => {
      if (data.status == 200) {
        let data = this.state.data
        data.splice(index, 1)
        modal.setState({ isLoadingRemove: false })
        this.refs.removeModal.hideModal()
        this.setState({ data })
      }

    }).catch(error => this.setState({ error, isLoading: false }));
  }




  editAction = (item, index) => {

    let newItem = JSON.stringify(item)
    newItem = JSON.parse(newItem)

    this.setState({ currentItem: newItem })
    this.setState({ selectedIndex: index }, () => {
      this.refs.itemModal.showModal()
      this.setState({ modalIsOpen: true })
    })
  }

  setModalIsOpen = (action) => {
    this.setState({ modalIsOpen: action })
  }

  removeAction = (info, index) => {
    this.refs.removeModal.showModal(this.state.data[index]._id, index)
    this.setModalIsOpen(true)
  }

  addAction = () => {
    // console.log("ADD ACTION")
    let item = {}
    item = this.makeNewItem()
    this.setState({ currentItem: {} }, () => {
      this.setState({ currentItem: item })
      this.setState({ selectedIndex: -1 }, () => {
        this.refs.addItemModal.showModal()
        this.setState({ modalIsOpen: true })
      })
    })

  }


  makeNewItem = () => {
    let helper = null
    let item = {}
    let temp = item

    if (this.props.page.helperKey && this.props.page.helperKey != '') {
      helper = this.props.page.helperKey
      item[helper] = {}
      temp = item[helper]
    }

    this.props.page.headers.forEach(header => {

      if (this.state.lockedItems && this.state.lockedItems[header.key]) {
        temp[header.key] = this.helperCheck(temp, header.key, helper)
      } else {
        if (header.type != 'button') {

          if (header.information.defaultValue) {
            temp[header.key] = header.information.defaultValue
          } else {
            temp[header.key] = ''
          }
        }
      }

    });

    return item

  }

  helperCheck(ref, key, helper) {
    if (helper) {
      return ref[helper][key]
    } else {
      return ref[key]
    }
  }


  changeValue = (key, value) => {

    let helper
    if (this.props.page.helperKey && this.props.page.helperKey != '') {
      helper = this.props.page.helperKey
    }

    let currentItem = this.state.currentItem

    if (helper) {
      currentItem[helper][key] = value

    } else {
      currentItem[key] = value
    }
    this.setState({ currentItem })
    // }

  }

  changeFiles = (files, key, type) => {
    if (!this.state.currentItem["**files"]) {
      this.state.currentItem["**files"] = {}
    }
    this.state.currentItem["**files"][key] = files
  }

  cancelModal = () => {
    this.setState({ modalIsOpen: false })
  }


  openActionsModal = (index) => {
    // console.log("HERE")
    this.setModalIsOpen(true)
    this.setState({ actionIndex: index }, () => {
      this.refs.actionsModal.showModal()

    })
  }


  butAction = (index, action) => {

    this.refs.actionsModal.hideModal()
    switch (action) {
      case 'remove':
        this.removeAction(this.state.data[index], index)
        break
      case 'edit':
        this.editAction(this.state.data[index], index)
        break
    }
  }



  openFilter = () => {

    this.setState({ modalIsOpen: true })
    let item = {}
    item['values'] = {}

    this.props.page.headers.forEach(header => {
      if (FilterFields[header.type]) {
        item.values[header.key] = {}
        // FilterFields[header.type].options.forEach(option => {
        //   if (option.default)
        //     item.values[header.key].operator = option.key
        // });
      }
    });

    // let filter

    // this.setState({ filterItem:  }, () => {
    this.refs.filterModal.showModal()
    // })
  }

  fetchFilter = () => {
    this.fetch(true)
    this.refs.filterModal.hideModal()
  }

  clearFilter = () => {
    this.setState({ filterItem: {}, filterItemMock: {} }, () => {
      this.fetch(true)
      this.refs.filterModal.hideModal()
    })
  }

  changeFilter = (key, value, operator) => {
    // if (operator) {
    //   this.state.filterItem.values[key].operator = value
    // } else {
    //   this.state.filterItem.values[key].value = value
    // }



    let filterItem = this.state.filterItem
    let filterItemMock = this.state.filterItemMock


    let newKey = key

    if (this.props.page.helperKey && this.props.page.helperKey != '') {
      newKey = this.props.page.helperKey + '.' + key
    }

    // if(this)

    let newValue = value

    if (newValue && newValue != '') {

      this.props.page.headers.forEach(header => {
        if (header.key == key) {
          if (header.type == 'textCell') {
            newValue = { $regex: value }
          }

          if (header.type == 'multiLevelCell') {
            newValue = { $all: value }
          }

        }
      });

      filterItem[newKey] = newValue
      filterItemMock[key] = value

    } else {
      delete filterItem[newKey]
      delete filterItemMock[newKey]
    }

    this.setState({ filterItem })
    this.setState({ filterItemMock })

    // console.log(filterItem)


  }
  // fetchFilter = () => {

  // }

  lockSend = () => {
    if (this.state.lockSend) {
      this.setState({ lockedItems: {} })
    }

    this.setState({ lockSend: !this.state.lockSend })
  }

  changeLockItems = (key) => {
    let lockedItems = this.state.lockedItems ? this.state.lockedItems : {}
    lockedItems[key] = lockedItems[key] ? !lockedItems[key] : true
    this.setState({ lockedItems })
  }

  showPage = () => {
    if (this.state.totalCount) {
      let pages = Math.ceil(this.state.totalCount / this.state.limit)
      // console.log(pages)
      if (pages > 1) {
        let array = []
        for (let i = 0; i < pages; i++) {
          array.push(i + 1)
        }

        let dotDone = false
        return (
          <div className="flexcc w-100" style={{ flexDirection: 'revert', overflow: 'auto' }}>{array.map((prop, index) => {
            if (index == 0 || index == array.length - 1 || (index > this.state.currentPage - 2 && index < this.state.currentPage + 3)) {
              dotDone = false

              return (
                <p onClick={() => this.changePage(index)} style={{ margin: 2, backgroundColor: this.state.currentPage == index ? "#007aff" : '#d2d8e299', color: this.state.currentPage == index ? "#fff" : '#789', borderRadius: 2, padding: '2px 10px', cursor: 'pointer' }}>{prop}</p>
              )

            } else {
              if (!dotDone) {
                dotDone = true
                return (
                  <p style={{ margin: 2, borderRadius: 2, padding: '2px 6px', }}>...</p>
                )
              }
            }
          })}
          </div>
        )
      }
    }
  }

  changePage = (index) => {
    console.log(index)
    this.setState({ currentPage: index }, () => {
      this.fetch()
    })
  }



  render() {
    if (true) {
      return (
        <div>

          <Container modules={this.props.modules} isOpen={true} modalIsOpen={this.state.modalIsOpen} location={this.props.location} >

            <div style={{ paddingRight: '6%', paddingLeft: '6%', }}>

              {!this.props.page && (
                <div className="text-center mt-4">
                  <Loader
                    type="ThreeDots"
                    color="#789"
                    height="60"
                    width="60"
                  />
                </div>
              )}

              {this.props.page && (
                <div>
                  <GuaranteePageHeader openFilter={this.openFilter} addAction={this.addAction} title={this.props.page.title} description={this.props.page.description} />
                  <TablePage openFilter={this.openFilter} page={this.props.page} openActionsModal={this.openActionsModal} data={this.state.data} headers={this.props.page.headers} addAction={this.addAction} removeAction={this.removeAction} editAction={this.editAction} options={this.props.page.options} isLoadingData={this.state.isLoadingData} />

                  {this.showPage()}
                </div>
              )}
            </div>

          </Container>

          {this.props.page && (
            <div>
              <RemoveModal removeFunction={this.fetchRemove} ref={'removeModal'} />

              {((this.state.selectedIndex != null && this.state.selectedIndex < this.state.data.length) || (this.state.selectedIndex == -1)) && (
                <ItemModal maxWidth={500} page={this.props.page} fetchAdd={() => this.fetchAdd()} changeValue={this.changeValue} changeFiles={this.changeFiles} removeFunction={this.fetchRemove} ref={'itemModal'} headers={this.props.page.headers} item={this.state.currentItem} lockSend={this.lockSend} isLocked={this.state.lockSend} lockedItems={this.state.lockedItems} changeLockItems={this.changeLockItems} />
              )}


              <ItemModal maxWidth={500} page={this.props.page} fetchAdd={() => this.fetchAddGuarantee()} changeValue={this.changeValue} changeFiles={this.changeFiles} removeFunction={this.fetchRemove} ref={'addItemModal'} headers={this.state.guaranteeHeaders} item={this.state.currentItem} lockSend={this.lockSend} isLocked={this.state.lockSend} lockedItems={this.state.lockedItems} changeLockItems={this.changeLockItems} />



              <FilterModal cancelModal={this.cancelModal} clearFilter={this.clearFilter} fetchFilter={() => this.fetchFilter()} changeValue={this.changeFilter} ref={'filterModal'} headers={this.props.page.headers} item={this.state.filterItemMock} />


              <Modal className="lightiransansfont" ref={'actionsModal'} maxWidth={250} style={{ alignItems: 'center', textAlign: 'center', display: 'flex', justifyContent: 'center' }} zIndex={1}>

                <div style={{ flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <p style={{ textAlign: 'center', fontSize: 20, marginTop: 0, fontWeight: 'bold' }}>عملیات ها</p>
                </div>


                <div className="mt-3" style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                  {this.state.actions.map((prop, index) => {
                    return (
                      <div className="mb-2">
                        <div style={{ flex: 1, flexDirection: 'column', position: 'relative' }} >
                          <div onClick={() => this.butAction(this.state.actionIndex, prop.action)} style={{ cursor: 'pointer', padding: 10, paddingLeft: 15, paddingRight: 15, borderRadius: 20, backgroundColor: prop.color + '25', justifyContent: 'center', alignItems: 'center' }}>
                            <p className={'mediumiransansfont'} style={{ margin: 7, color: '#fff', textAlign: 'center', fontSize: 13, margin: 0, color: prop.color }}>{prop.title}</p>
                          </div>
                        </div>
                      </div>
                    )
                  })}

                </div>

              </Modal>



              {/* <Modal className="lightiransansfont" ref={"downloadFile"} maxWidth={250} style={{ alignItems: 'center', textAlign: 'center', display: 'flex', justifyContent: 'center' }} zIndex={1}>

                <div style={{ flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <p style={{ textAlign: 'center', fontSize: 20, marginTop: 0, fontWeight: 'bold' }}>Download File</p>
                  <p style={{ textAlign: 'center', fontSize: 14, marginTop: 0, }}>Download the excel file</p>

                </div>



                <div className="mt-3" style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <button onClick={()=>this.downloadFile()} style={{backgroundColor:'#007aff',padding:'10px 25px',color:'#fff',borderRadius:8,fontWeight:'bold'}}>Download</button>

                </div>

              </Modal> */}

            </div>

          )}


        </div>

      );
    } else {
      return (<div></div>)
    }
  }

}

export default GuaranteeApplet;
